const locationLifeinfo = (() => {
  const pageLocation = (document.getElementById("pageLocation") != null);
  if (pageLocation) {

    let tabBtn = document.querySelectorAll('.js-tab-btn');
    // let tabBtn2 = document.querySelectorAll('.js-tab-btn2');
    let map = document.querySelectorAll('.js-tab-map');
    let map1 = document.querySelector('.js-tab-map');
    let img = document.querySelectorAll('.js-img-area');
    let imgWrap1 = document.querySelector('.js-img-wrap');
    let list = document.querySelectorAll('.js-list-box');
    let sW = window.innerWidth;

    let target = 360;

    for (let i = 0; i < tabBtn.length; i++) {
      tabBtn[i].addEventListener("click", () => {

        // 押されたiとjが同じだったらactとらない
        for (let j = 0; j < tabBtn.length; j++) {
          if (!(j == i)) {
            // console.log(j);
            tabBtn[j].classList.remove("act");
            // tabBtn2[j].classList.remove("act");
            map[j].classList.remove("act");
            img[j].classList.remove("act");
            list[j].classList.remove("act");
          }
        }

        tabBtn[i].classList.add('act');
        // tabBtn2[i].classList.add('act');
        map[i].classList.add('act');
        img[i].classList.add('act');
        list[i].classList.add('act');
      });
    }

    // for (let i = 0; i < tabBtn2.length; i++) {
    //   tabBtn2[i].addEventListener("click", () => {

    //     // 押されたiとjが同じだったらactとらない
    //     for (let j = 0; j < tabBtn2.length; j++) {
    //       if (!(j == i)) {
    //         // console.log(j);
    //         tabBtn[j].classList.remove("act");
    //         tabBtn2[j].classList.remove("act");
    //         map[j].classList.remove("act");
    //         img[j].classList.remove("act");
    //         list[j].classList.remove("act");
    //       }
    //     }

    //     tabBtn[i].classList.add('act');
    //     tabBtn2[i].classList.add('act');
    //     map[i].classList.add('act');
    //     img[i].classList.add('act');
    //     list[i].classList.add('act');
    //   });
    // }


    imgWrap1.scrollTo({
      left: 0,
    });

    for (let i = 0; i < tabBtn.length; i++) {
      tabBtn[i].addEventListener('click', (event) => {
        imgWrap1.scrollTo({
          left: 0,
        });
      });
    }
    // for (let i = 0; i < tabBtn.length; i++) {
    //   tabBtn2[i].addEventListener('click', (event) => {
    //     imgWrap1.scrollTo({
    //       left: 0,
    //     });
    //   });
    // }


    if (!(sW > 750)) {
      // console.log("object");
      map1.scrollTo({
        left: target,
      });

      for (let i = 0; i < tabBtn.length; i++) {
        tabBtn[i].addEventListener('click', (event) => {
          map[i].scrollTo({
            left: target,
            // behavior: 'smooth',
          });
        });
      }
    }

  }
})();
export default locationLifeinfo;